// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Site-wide print stylesheet. Imported once from index.js.
  Goal: when a reader prints (or saves to PDF) a blog post or case study,
  they get the content cleanly without nav/footer/CTAs/widgets.

  Rules are deliberately conservative so non-article pages also print
  reasonably (just slightly less polished).
*/

@media print {
  /* Hide all chrome: header, footer, floating widgets, banners */
  .technumopus-header,
  .technumopus-sidebar,
  .technumopus-sidebar-overlay,
  .technumopus-footer,
  .tohome-footer,
  .tn-consent,
  .tn-newsletter-sticky,
  .tn-exit-intent,
  .tn-a11y-toggle,
  .tn-a11y-panel,
  .tn-toast-host,
  .tn-reading-progress,
  .tn-blog-toc,
  .tn-share,
  .tn-helpful,
  .technum-bot,
  .skip-to-content {
    display: none !important;
  }

  /* Light theme, optimised for ink on paper */
  body, html {
    background: #fff !important;
    color: #111 !important;
  }

  a, a:visited {
    color: #111 !important;
    text-decoration: underline;
  }

  /* Surface external link URLs after the anchor text so the print is useful
     without a screen. Skip in-app links (relative, mailto, tel). */
  a[href^="http"]::after {
    content: " (" attr(href) ")";
    font-size: 0.85em;
    opacity: 0.7;
  }

  /* No page break inside paragraphs / list items */
  p, li, blockquote { page-break-inside: avoid; }

  /* Keep headings with their following content */
  h1, h2, h3, h4 { page-break-after: avoid; }

  /* Drop heavy backgrounds that waste ink */
  section, header, footer, div, aside {
    background: transparent !important;
    box-shadow: none !important;
  }

  /* Constrain images so they don't run off the page */
  img, video {
    max-width: 100% !important;
    height: auto !important;
    page-break-inside: avoid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/print.css"],"names":[],"mappings":"AAAA;;;;;;;CAOC;;AAED;EACE,+DAA+D;EAC/D;;;;;;;;;;;;;;;;;IAiBE,wBAAwB;EAC1B;;EAEA,4CAA4C;EAC5C;IACE,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;mEACiE;EACjE;IACE,4BAA4B;IAC5B,iBAAiB;IACjB,YAAY;EACd;;EAEA,iDAAiD;EACjD,oBAAoB,wBAAwB,EAAE;;EAE9C,+CAA+C;EAC/C,iBAAiB,uBAAuB,EAAE;;EAE1C,0CAA0C;EAC1C;IACE,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA,oDAAoD;EACpD;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,wBAAwB;EAC1B;AACF","sourcesContent":["/*\n  Site-wide print stylesheet. Imported once from index.js.\n  Goal: when a reader prints (or saves to PDF) a blog post or case study,\n  they get the content cleanly without nav/footer/CTAs/widgets.\n\n  Rules are deliberately conservative so non-article pages also print\n  reasonably (just slightly less polished).\n*/\n\n@media print {\n  /* Hide all chrome: header, footer, floating widgets, banners */\n  .technumopus-header,\n  .technumopus-sidebar,\n  .technumopus-sidebar-overlay,\n  .technumopus-footer,\n  .tohome-footer,\n  .tn-consent,\n  .tn-newsletter-sticky,\n  .tn-exit-intent,\n  .tn-a11y-toggle,\n  .tn-a11y-panel,\n  .tn-toast-host,\n  .tn-reading-progress,\n  .tn-blog-toc,\n  .tn-share,\n  .tn-helpful,\n  .technum-bot,\n  .skip-to-content {\n    display: none !important;\n  }\n\n  /* Light theme, optimised for ink on paper */\n  body, html {\n    background: #fff !important;\n    color: #111 !important;\n  }\n\n  a, a:visited {\n    color: #111 !important;\n    text-decoration: underline;\n  }\n\n  /* Surface external link URLs after the anchor text so the print is useful\n     without a screen. Skip in-app links (relative, mailto, tel). */\n  a[href^=\"http\"]::after {\n    content: \" (\" attr(href) \")\";\n    font-size: 0.85em;\n    opacity: 0.7;\n  }\n\n  /* No page break inside paragraphs / list items */\n  p, li, blockquote { page-break-inside: avoid; }\n\n  /* Keep headings with their following content */\n  h1, h2, h3, h4 { page-break-after: avoid; }\n\n  /* Drop heavy backgrounds that waste ink */\n  section, header, footer, div, aside {\n    background: transparent !important;\n    box-shadow: none !important;\n  }\n\n  /* Constrain images so they don't run off the page */\n  img, video {\n    max-width: 100% !important;\n    height: auto !important;\n    page-break-inside: avoid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
